import { CTL_ROUTES } from '../../../navigation/paths';

export type ResolvedLink = { readonly kind: 'inApp'; readonly path: string } | { readonly kind: 'external'; readonly href: string };

export const resolveLink = (link: string, origin: string): ResolvedLink => {
  if (link.startsWith('/')) return { kind: 'inApp', path: link };
  const url = new URL(link);
  if (url.origin !== origin) return { kind: 'external', href: link };
  return { kind: 'inApp', path: `${url.pathname}${url.search}${url.hash}` };
};

export interface LinkedRecord {
  readonly link: string | null;
  readonly issueId: string | null;
}

export const recordLinkOf = (record: LinkedRecord): string | null => {
  if (record.link !== null) return record.link;
  return record.issueId === null ? null : CTL_ROUTES.issue(record.issueId);
};

export const START_INTENT_PARAM = 'action';
export const START_INTENT = 'start';

const RELATIVE_BASE = 'https://relative.invalid';

export const withStartIntent = (link: string): string => {
  const url = new URL(link, RELATIVE_BASE);
  url.searchParams.set(START_INTENT_PARAM, START_INTENT);
  const tail = `${url.pathname}${url.search}${url.hash}`;
  return url.origin === RELATIVE_BASE ? tail : `${url.origin}${tail}`;
};

export const hasStartIntent = (search: string): boolean =>
  new URLSearchParams(search).get(START_INTENT_PARAM) === START_INTENT;
